module.exports = __webpack_public_path__ + "media/images/frontend/search-c90f1348bfa867103b1f3eaeeccbe0e7.svg";